import { Link } from "react-router-dom";
import { Trash2, CheckSquare, Square, Paperclip, Hammer } from "lucide-react";
import { downloadFile } from "../../lib/api";
import { VisibilityBadge } from "../../lib/taskVisibility";

const SENT_LABEL = { email: "e-mailem", doporucene: "doporučeně", datova_schranka: "datovou schránkou" };

export function TaskRow({ t, todayISO, onToggle, onEdit, onDelete, sent, setSent, onMarkSent, office }) {
    const overdue = !t.done && t.due_date && t.due_date < todayISO;
    const s = sent[t.id] || {};
    return (
        <div data-testid={`task-row-${t.id}`}
             className={`flex items-start gap-3 px-4 sm:px-6 py-4 border-b border-slate-100 hover:bg-orange-50/30 ${t.done ? "opacity-50" : ""}`}>
            <button onClick={() => onToggle(t)} data-testid={`task-toggle-${t.id}`} className="mt-0.5 text-slate-400 hover:text-orange-600 shrink-0">
                {t.done ? <CheckSquare className="w-5 h-5 text-emerald-600" /> : <Square className="w-5 h-5" />}
            </button>
            <div className="flex-1 min-w-0">
                <div className="flex items-start gap-2 flex-wrap">
                    <VisibilityBadge visibility={t.visibility} testid={`task-visibility-${t.id}`} className="mt-0.5" />
                    {t.can_edit
                        ? <button onClick={() => onEdit(t)} data-testid={`task-title-${t.id}`} className={`text-left font-medium text-slate-900 hover:text-orange-600 ${t.done ? "line-through" : ""}`}>{t.title}</button>
                        : <span data-testid={`task-title-${t.id}`} className={`font-medium text-slate-900 ${t.done ? "line-through" : ""}`}>{t.title}</span>}
                </div>
                {t.description && <div className="text-xs text-slate-500 mt-0.5 whitespace-pre-line">{t.description}</div>}
                {t.attachments?.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid={`task-attachments-${t.id}`}>
                        {t.attachments.map((a, i) => (
                            <button key={i} onClick={() => downloadFile(`/tasks/${t.id}/attachments/${i}`, a.name)}
                                    className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 border border-slate-300 hover:border-orange-600 rounded-sm">
                                <Paperclip className="w-3 h-3" /> {a.name}
                            </button>
                        ))}
                    </div>
                )}
                {office && !t.done && (t.kind === "upominka" || t.kind === "predzalobni") && (
                    <div className="flex items-center gap-2 mt-2 flex-wrap" data-testid={`task-sent-${t.id}`}>
                        <select value={s.method || "email"} onChange={(e) => setSent({ ...sent, [t.id]: { ...s, method: e.target.value } })}
                                className="text-xs border border-slate-300 px-2 py-1 rounded-sm" data-testid={`task-sent-method-${t.id}`}>
                            <option value="email">e-mailem</option><option value="doporucene">doporučeně</option><option value="datova_schranka">datovou schránkou</option>
                        </select>
                        <input type="date" value={s.date || todayISO} onChange={(e) => setSent({ ...sent, [t.id]: { ...s, date: e.target.value } })} className="text-xs border border-slate-300 px-2 py-1 rounded-sm" />
                        <button onClick={() => onMarkSent(t)} data-testid={`task-mark-sent-${t.id}`} className="text-xs px-3 py-1 bg-slate-900 text-white uppercase tracking-wider font-semibold rounded-sm">Odesláno</button>
                    </div>
                )}
                {office && !t.done && t.kind === "danovy_doklad" && t.invoice_id && (
                    <Link to={`/faktury/${t.invoice_id}?dd=1`} data-testid={`task-tax-doc-${t.id}`} className="inline-block mt-2 text-xs px-3 py-1 bg-emerald-700 text-white uppercase tracking-wider font-semibold rounded-sm">Vystavit daňový doklad</Link>
                )}
                {t.done && t.sent && <div className="text-[11px] text-emerald-700 mt-1">Odesláno {t.sent.sent_at} ({SENT_LABEL[t.sent.method]})</div>}
                <div className="flex gap-3 mt-1 text-[11px] text-slate-500 flex-wrap">
                    {t.assignee_name && <span className="text-orange-700 font-semibold" data-testid={`task-assignee-${t.id}`}>→ {t.assignee_name}</span>}
                    {t.created_by_name && <span>od {t.created_by_name}</span>}
                    {t.job_title && <Link to={`/zakazky/${t.job_id}`} className="hover:underline inline-flex items-center gap-1"><Hammer className="w-3 h-3" /> {t.job_title}</Link>}
                    {t.due_date && (
                        <span className={overdue ? "text-red-600 font-bold" : ""} data-testid={`task-due-${t.id}`}>
                            Termín: {new Date(t.due_date + "T12:00:00").toLocaleDateString("cs-CZ")}{overdue && " — po termínu!"}
                        </span>
                    )}
                </div>
            </div>
            {t.can_edit && (
                <button onClick={() => onDelete(t.id)} data-testid={`task-delete-${t.id}`} className="text-slate-400 hover:text-red-600 mt-1 shrink-0"><Trash2 className="w-3.5 h-3.5" /></button>
            )}
        </div>
    );
}
